import { hasFreeBoardLimitDefined } from './hasFreeBoardLimitDefined';

/**
 * Indicates how many open boards the organization already has.
 */
export const openBoardCount = <Team>(team: Team): number | undefined => {
  if (!hasFreeBoardLimitDefined(team)) {
    return undefined;
  }

  return team.limits.orgs.freeBoardsPerOrg.count;
};
